import defaultPageStyles from "src/assets/jss/material-kit-react/defaultPageStyles"

const termsPageStyles = {
  body: {
    ...defaultPageStyles
  }
}

export default termsPageStyles
